import ErrorPage from '../pages/other/ErrorPage';
import LoginPage from '../pages/login/LoginPage';
import SettingsPage from '../pages/settings/SettingsPage';
import {env} from './env';
import {PrivateRouteProps, RouteType} from './routeType';

export function routeSettings(): RouteType<PrivateRouteProps>[] {
  return [
    {
      path: '/settings/*',
      component: SettingsPage,
    },
    ...(env.isDev
      ? [
          {
            path: '/checkLogin',
            component: LoginPage,
          },
          {
            path: '/checkError',
            component: ErrorPage,
          },
        ]
      : []),
  ];
}
